import {SUPERVISION_COMPANIES_LOAD, SUPERVISION_REGISTERED_LOAD, SUPERVISION_UNLOAD} from '../../actions/Constants';

const INITIAL_STATE = {registred: [], companies: []} ;

export default function aprove(state = INITIAL_STATE, action) {
  switch (action.type) {

    case SUPERVISION_UNLOAD:
      return INITIAL_STATE;
    case SUPERVISION_REGISTERED_LOAD:
      return {
        ...state,
        registered: action.payload ? action.payload : null,
      };
    case SUPERVISION_COMPANIES_LOAD:
      return {
        ...state,
        companies: action.payload ? action.payload : null,
    };

    // initial state
    default:
      return state;
  }
  return state;
}
